const differentFields: string[] = [
  'material',
  'density',
  'code',
  'format',
  'finishing',
  'fabrication',
  'heatTreatment',
  'ncm',
  'originCountry',
  'stockStreet',
  'shelf',
  'stockLocation',
  'createdBy',
]

const numberFields: string[] = [
  'quantity',
  'totalWeight',
  'dimension1',
  'dimension2',
  'lengthInMm',
  'costPerKg',
  'costPerMm',
  'totalCost',
  'totalCmc',
  'runNumber',
  'availableBalance',
]

const textFields: string[] = [
  'trackingNumber',
  'family',
  'description',
  'stockStatus',
  'characteristic',
  'receivedDate',
  'purchaseOrder',
  'nf',
  'certificateNumber',
]

export const textHeaders: string[] = [
  'Material',
  'Densidade',
  'Código',
  'Formato',
  'Acabamento',
  'Tratamento Térmico',
  'Ncm',
  'País de origem',
  'Rua',
  'Prateleira',
  'Localização',
  'Número de Rastreamento',
  'Família',
  'Data de Recebimento',
  'Ordem de Compra',
  'NF',
  'Número do Certificado',
  'Matéria prima',
  'Tipo do movimento',
  'Data',
]

export const numberHeaders: string[] = [
  'Qtd. (pç)',
  'Peso (kg)',
  'Dimensão 1 (mm)',
  'Dimensão 2 (mm)',
  'Comprimento (mm)',
  'Custo (R$/kg)',
  'Custo (R$/mm)',
  'Densidade (g/cm³)',
  'Custo total',
  'CMC Total',
  'Número da Corrida',
  'Saldo Disponível',
  'Pedido',
  'Quantidade',
  'Peso anterior',
  'Peso novo',
  'Comp. anterior',
  'Comp. novo',
]
